export class DomainError extends Error {}
